var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingTaskComplete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 13.3333C10.3486 13.3333 13.3333 10.3486 13.3333 6.66667C13.3333 2.98477 10.3486 0 6.66667 0C2.98477 0 0 2.98477 0 6.66667C0 10.3486 2.98477 13.3333 6.66667 13.3333ZM9.75592 5.58926C10.0814 5.26382 10.0814 4.73618 9.75592 4.41074C9.43049 4.08531 8.90285 4.08531 8.57741 4.41074L5.83333 7.15482L4.75592 6.07741C4.43049 5.75197 3.90285 5.75197 3.57741 6.07741C3.25197 6.40285 3.25197 6.93048 3.57741 7.25592L5.24408 8.92259C5.56951 9.24803 6.09715 9.24803 6.42259 8.92259L9.75592 5.58926Z",
    fill: "#3A836C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingTaskComplete);
export default __webpack_public_path__ + "static/media/onboarding-task-complete.81f4d9c555622e7b94f35a79d2240088.svg";
export { ForwardRef as ReactComponent };